var stepSchema = {
    1: {
        workLocation: '',
        workLocationChild: '',
        appType: '',
        productType: '',
        rateType: '',
        workLocationGrandChild: '',
        workLocationGrandChildSuboption: '',
        isInternational: false,
        isMilitary: '',
        isPdf: '',
        pdfLink: ''
    },
    2: {
        prefix: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        primaryPracticeLocation: '',
        primaryDistrictLocation: '',
        yearsInPractice: -1,
        credentials: [],
        emailLocation: '',
        email: '',
        password: '',
        applicationSubmitted: false,
        showPassword: false,
        componentMarkup: {}
    },
    3: {
        rank: '',
        branch: '',
        branchId: '',
        branchIdToDelete: '',
        gender: '',
        race: [],
        birthdate: '',
        addressType: '',
        country: '',
        companyName: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        city: '',
        state: '',
        zip: '',
        
        governmentSector: '',
        governmentSectorId: '',
        governmentSectorIdToDelete: '',
        addressId: '',
        addressStatus: '',
        billToFlag: false,
        formattedAddress: '',
        isPrimaryAddress: false,
        postalCode: '',
        shipToFlag: false,

        phoneNumber: '',
        phoneLocation: '',
        includeInMemberDirectory: false,
        componentMarkup: {}
    },
    4: {
        primaryPracticeLocation: '',
        primaryDistrictLocation: '',
        npiNumber: '',
        activeLicenses: [],
        boardCertification: '',
        boardCertificationId: '',
        boardCertificationNumber: '',
        boardCertificationDate: '',
        hasBoardSubSpecialty: false,
        boardSubSpecialties: [],
        boardSubSpecialtiesToDelete: [],
        componentMarkup: {}
    }, 
    5: {
        medSchoolCountry: '',
        medSchoolState: '',
        medSchoolProgramType: '',
        medSchoolProgramDegree: '',
        medSchoolProgramDirectorName: '',
        medSchoolProgramDirectorEmail: '',
        medSchoolInstitution: '',
        medSchoolCustomInstitution: '',
        medSchoolStartDate: '',
        medSchoolEndDate: '',
        medSchoolCustomerEducationId: '',
        residencyCountry: '',
        residencyState: '',
        residencyInstitution: '',
        residencyCustomInstitution: '',
        residencyProgramDegreeCodeString: '',
        residencyProgramType: '',
        residencyStartDate: '',
        residencyEndDate: '',
        residencyCustomerEducationId: '',
        fellowships: [],
        agreement1: false,
        agreement2: false,
        agreement3: false,
        componentMarkup: {}
    },
    6: {
        ccNumber: '',
        ccName: '',
        ccExpirationMonth: '',
        ccExpirationYear: '',
        ccExpirationDate: '',
        ccSecurityCode: '',

        useStep3ForBillingAddress: false,
        step3AddressType: '',

        addressId: '',
        companyName: '',
        country: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        city: '',
        state: '',
        zip: '',
        phoneNumber: '',
        autorenewflag: false,
        componentMarkup: {},
        yearsInPractice: -1

    }
}

module.exports = stepSchema;